<vectronic-card [title]="'Filters'" [displayClose]="true" (closed)="dialogRef.close()">
  <div body class="dialog-body-wrapper">
    <mat-dialog-content class="mobile-filters-dialog">
      <table-datatable-filters
        [filters]="data.filters"
        [activeFilters]="activeFilters()"
        [selectionFilters]="selectionFilters()"
        [selectedSelectionFilter]="selectedSelectionFilter()"
        [showSavedFiltersButton]="!!selectionFilters().length"
        (filterChange)="onFilterChange($event)"
        (saveSelectionFilter)="onSaveSelectionFilter($event)"
        (editSelectionFilter)="onEditSelectionFilter($event)"
        (deleteSelectionFilter)="onDeleteSelectionFilter($event)"
        (selectionFilterChange)="onSelectionFilterChange($event)"
        (closeEvent)="dialogRef.close()"
        [headless]="true"
      ></table-datatable-filters>
    </mat-dialog-content>
  </div>
</vectronic-card>
